import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    jwt: ""
};
const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {}
});
export { authSlice };
//# sourceMappingURL=auth.slice.js.map